export default [
  {
    key: 1,
    name: 'Broken',
    value: 'BROKEN',
    subOption: false,
  },
  {
    key: 2,
    name: 'Maintenance',
    value: 'MAINTENANCE',
    subOption: false,
  },
  {
    key: 3,
    name: 'Spare',
    value: 'SPARE',
    subOption: false,
  },
  {
    key: 4,
    name: 'Booking',
    value: 'BOOKING',
    subOption: false,
  },
];
